<div scrollIntoView class="scrollAnchor" *ngIf="searchState?.scrollToTop"></div>

<cdx-wapple-loading *ngIf="loading"></cdx-wapple-loading>

<div class="contentContainer">
	<search-results-header
		*ngIf="filteringEnabled && !!searchState && (breakPointService.device$ | async) === device.MOBILE"
		[heading]="headerTitle"
		[totalItems]="totalItems"
	></search-results-header>

	<search-das-filter
		*ngIf="filteringEnabled"
		[boostOfferTag]="searchState?.boostOfferTag"
		[dasFacets]="searchState.dasFacets"
		[filterGroups]="filterGroups"
		[selectedFilters]="selectedPiesFilters"
		[selectedDasFacets]="!!lastSelectedDasFilter ? [lastSelectedDasFilter] : []"
		[marginTop]="piesHeaderHeight"
		(filterChange)="onDasFilterChanged($event)"
		(facetChange)="onDasFacetChanged($event)"
		(clearFilters)="onClearFilters()"
	></search-das-filter>

	<main class="contentContainer-main" *ngIf="products$ | async as products">
		<search-pies-header
			*ngIf="filteringEnabled"
            #piesHeader
			[heading]="headerTitle"
			[filterGroups]="filterGroups"
			[selectedFilters]="selectedPiesFilters"
			[sortOptions]="searchState?.sortOptions"
			[currentSortOption]="searchState?.currentSortOption"
			[totalItems]="totalItems"
			[boostOfferTag]="searchState?.boostOfferTag"
			[enableSwitchToggleShowInStock]="isShowInStockItemsOnlyFeatureEnabled$ | async"
			[enableHideSwitchToggleForOOS]="isHideSwitchToggleForOOSEnabled$ | async"
			(removeFilter)="onRemoveFilter($event)"
			(removeAllFilters)="onRemoveAllFilters()"
			(sortChange)="onSortChanged($event)"
		>
		</search-pies-header>

		<dc-carousel
			[name]="name"
			[title]="filteringEnabled ? '' : headerTitle"
			[titleIsMobileOnly]="titleIsMobileOnly"
			[displaytype]="displayType"
			[cta]="cta"
			[hero]="hero"
			[analyticsID]="analyticsID"
			[isloggedin]="isLoggedIn$ | async"
			[isshopper]="isShopper$ | async"
			[products]="products"
			[ngClass]="{
						'filtered-grid': filteringEnabled && displayType === 'grid',
						'filtered-carousel': filteringEnabled && displayType === 'carousel'
					}"
		>
		</dc-carousel>

		<search-footer
			*ngIf="filteringEnabled"
			[totalItems]="totalItems"
			[itemsPerPageCollection]="itemsPerPageCollection"
			[minimumPageSize]="minimumPageSize"
			[itemsCount]="products.length"
			[currentPage]="searchState?.currentPage"
			[currentPageSize]="searchState?.currentPageSize"
		></search-footer>

		<div class="cta-footer-container" *ngIf="showFooterCta && products.length">
			<button
				cdxButton
				fillStyle="outline"
				[routerLink]="ctaUrl"
				[cdxTrackEvent]="{
				event: trackingEvent.NotificationEvent,
				type: notificationType.Button,
				name: '{{name}} CTA',
				value: ''
			}"
			>
				{{ctaLinkText}}
			</button>
		</div>
	</main>
</div>
